import { checkoutShippingAddressesStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

checkoutShippingAddressesStyles.pickUpAddress = {
    findLocationLink: {
        css: css`
            /* Not needed  */
            display: none;
        `,
    },
};
checkoutShippingAddressesStyles.billingAddressGridItem = { width: [12, 12, 12, 6, 6] };
checkoutShippingAddressesStyles.billingAddress = {
    addressDisplayAndFormGridItem: {
        css: css`
            padding-top: 25px;
            > address > p {
                color: ${getColor("text.main")};
            }
            > address > span {
                color: ${getColor("text.main")};
            }
        `,
    },
    addressBookModalCancelButton: {
        css: css`
            padding: 10px 34px;
            span[class^="TypographyStyle"] {
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
        `,
    },
};
checkoutShippingAddressesStyles.shippingAddress = {
    oneTimeAddressGridItem: {
        css: css`
            padding-top: 25px;
        `,
    },
    addressBookModalCancelButton: {
        css: css`
            padding: 10px 34px;
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("primary")} !important;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
        `,
    },
};
